import { useCallback, useState } from "react";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";
import { TCompradoresEstoque } from "../../../../../types/api/estoque/compradores-estoque";
import DialogCriacaoEditCompradores from "./DialogCriacaoEditCompradores";

export default function Compradores() {

  const [openModal, setOpenModal] = useState<TOpenModalComprador>(null)

  //funções manipuladoras
  const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TCompradoresEstoque | null) => {
    if (action === "close") setOpenModal(null)
    if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
    if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
  }, [])
  //

  return (
    <>
      <SessaoConfiguracao<TCompradoresEstoque>
        titulo="Compradores"
        endpoints={{
          listar: "estoque/configuracoes/pesquisar-compradores",
          deletar: "estoque/configuracoes/excluir-comprador",
        }}
        colunas={colunas}
        queryKey="pesquisar-compradores"
        onEditar={(comprador) => {
          handleModalAction("open", comprador.id, comprador)
        }}
        onAdicionar={() => {
          handleModalAction("open", true, null)
        }}
        mensagemSucessoDeletar="Comprador deletado com sucesso!"
        mensagemErroDeletar="Erro ao deletar comprador!"
        mensagemSemDados="Nenhum comprador encontrado."
      />

      {Boolean(openModal?.open) && (
        <DialogCriacaoEditCompradores
          open={Boolean(openModal?.open)}
          handleClose={() => {
            handleModalAction("close")
          }}
          defaultValue={openModal?.defaultValue ? openModal : null}
        />
      )}
    </>
  );
}

export type TOpenModalComprador = {
  open: number | boolean | null;
  defaultValue: TCompradoresEstoque | null;
} | null

const colunas: ConfiguracaoColunas<TCompradoresEstoque>[] = [
  {
    campo: "nome",
    titulo: "Nome",
  },
];
